
import { Button, Input, Spinner } from "@swivl-mono/ui";

import AppsModel from "../../../../Models/Apps/Apps.Model";
import { AppInterface } from "@swivl-mono/types";
import { useSearchParams } from "react-router-dom";


interface Props {
  app:AppInterface
  selected?:boolean
}
export default function MandrilAppView(props:Props) {
    const { app, selected } = props;
    let content;
  
    

    function onChange(e) {
        var mandrill = app
    
        const name = e.target.name;
        const value = e.target.value;
        if (name === "mandrill_api_key") {
          var token = mandrill.token || {}
          token.mandrill_api_key = value;
          mandrill.token=  token;
        } else {
          var data = mandrill.data|| {};
          data[name] = value;
          mandrill.data = data;
        }
        AppsModel.update(mandrill,false);
      }
   
      function onBlur(e) {
        AppsModel.update(app, true);
      }
    // {
    //   "mandrill_api_key": "yINz6SQNdJmITgQJNWWkHQ",
    //   "mandrill_from_name": "Ellen Byrd",
    //   "mandrill_from_email": "mason@tryswivl.com"
    // }
    if  (!app) {
      content = <Spinner />;
    }  else {

        let mandrill_api_key = app.token.mandrill_api_key || ""
    //   const data = mandrill.get("data") || {}
      let mandrill_from_name = app.data.mandrill_from_name || "";
      let mandrill_from_email = app.data.mandrill_from_email || "";

      content = <div className="mandrillValues">
                  <label>From Name</label>
                  <Input name="mandrill_from_name" value={mandrill_from_name} onChange={onChange} onBlur={onBlur} />
                  <label>From Email Address</label>
                  <Input name="mandrill_from_email" value={mandrill_from_email} onChange={onChange} onBlur={onBlur} />
                  <label>Mandrill API Key</label>
                  <Input name="mandrill_api_key" value={app.token.mandrill_api_key} onChange={onChange} onBlur={onBlur} />
            </div>;
    }



    return  <div className="MandrillView">

      {content}
      </div>;

}

